import React from "react";
import { landingStyles } from "components/Landing/landingStyles";
import HeroBanner from "components/Marketing/Components/HeroBanner";
import Footer from "components/Footer";
import FeatureGrid from "./FeatureGrid";
import LogoConnection from "components/LogoConnection";
import { BUTTON_TAGS, STATUS } from "utils/constants/ui";
import Pill from "components/Pill";
import { cellGrow } from "constants/styles";

/**
 * Main publicly listed integration page
 */
export const ZAPIER_LINK = "https://zapier.com/apps/priceblocs/integrations";
/**
 * Old invite to integration link
 */
export const ZAPIER_BETA_INVITE_LINK =
  "https://zapier.com/developer/public-invite/122532/656460470eea925459da76417f21bbea/";

const MarketingIntegrationsZapier = () => {
  const heroProps = {
    header: [
      {
        copy: "Sell anywhere,"
      },
      {
        classes: "color-primary underline",
        copy: "connect to"
      },
      {
        copy: "anything."
      }
    ],
    action: {
      tag: BUTTON_TAGS.ANCHOR,
      href: ZAPIER_LINK,
      copy: "Try",
      classes: {
        button:
          "fw6 br2 ph3 pv2 border-box input-reset ba bg-transparent pointer f4 dib link items-center flex flex-shrink-0 cell-grow"
      }
    },
    paddingBottom: 20,
    bgImage: "hero_bg_integrations_zapier",
    subheader:
      "Connect your customer checkout data to all of your favorite apps."
  };

  return (
    <div className="w-100 relative">
      <div className="mw8 center">
        <HeroBanner {...heroProps} />
        <div className="pb3">
          <a target="_blank" href={ZAPIER_LINK} className="pointer cell-grow">
            <LogoConnection src="/assets/priceblocs_zapierConnect.png" />
          </a>
        </div>
        <div className="pa3 pb5">
          <FeatureGrid />
        </div>
        <div className="pt5 hairline-1 bt">
          <Footer />
        </div>
      </div>
      <style jsx>{landingStyles}</style>
      <style jsx>{cellGrow}</style>
    </div>
  );
};

export default MarketingIntegrationsZapier;
